// extracted by mini-css-extract-plugin
export default {"card":"styles_card__HEe7R","imageContainer":"styles_imageContainer__7p6bp","image":"styles_image__LaDWA"};